import React, { FC, MutableRefObject, ReactElement, useMemo, useRef } from 'react'
import { TimezoneFormData } from '../Types/Types'
import { useForm, UseFormMethods } from '../../../Vendor/react-hook-form/dist/index.ie11'
import { ON_CHANGE } from '../../Common/Constants/HookFormEventNames'
import { DEFAULT_TIMEZONE } from '../Constants/Constants'
import { ModalUtilsProvider } from '../../Common/Contexts/ModalUtilsContext'
import { TimezoneContent } from './TimezoneContent'

type Props = {
    closeModal: () => void
}

export const Timezone: FC<Props> = ({ closeModal }: Props): ReactElement => {
    // Sets the default values for the form within the Modal.
    const defaultValues: MutableRefObject<TimezoneFormData> = useRef({
        timezone: DEFAULT_TIMEZONE
    })

    // Form context.
    const methods: UseFormMethods = useForm<TimezoneFormData>({
        defaultValues: defaultValues.current,
        mode: ON_CHANGE,
        reValidateMode: ON_CHANGE,
        shouldUnregister: false
    })

    // get all properties from defaultValues
    const validationFields: string[] = useMemo(
        (): string[] => Object.keys(defaultValues.current),
        [JSON.stringify(defaultValues.current)]
    )

    return (
        <ModalUtilsProvider validationFields={validationFields} closeModal={closeModal} methods={methods}>
            <TimezoneContent closeModal={closeModal} methods={methods} />
        </ModalUtilsProvider>
    )
}
